"use strict";

var $ = require("jquery");

function dropdownPositionRight(el, trigger) {
    if ($(window).width() >= 992) {
        if (trigger.offset()) {
            let positionRight = ($(window).width() - (trigger.offset().left + trigger.outerWidth()));
            el.css({ right: positionRight });
        }
    } else {
        el.css({ 'right': '' });
    }
}

export { dropdownPositionRight };